import { Component, createSignal, For, onMount, Show } from "solid-js";
import { CMS } from "../cms/cms";
import moment from "moment";
import { createStore } from "solid-js/store";
import { Img } from "../universal/image";

type Notification = {
    URL: string;
    ImageURL: string;
    Text: string;
    DateAddedUTC: string;
}

type NotificationProps = {
    items: Notification[];
}

const Image : Component<{ targetUrl: string; imageUrl: string; }> = (props) => {
    return (
        <>
            <Show when={props.imageUrl}>
                <span style="margin-right: 10px;">
                    <a href={props.targetUrl}>
                        <Img src={props.imageUrl} mode="crop" width={40} height={40} style="width: 100%; height: auto; object-fit: cover;" />
                    </a>
                </span>
            </Show>
            <Show when={!props.imageUrl}>
                <span style="margin-right: 10px; width: 40px; height: 40px; background-color: #efefef;"></span>
            </Show>
        </>
    )
};

const Notifications : Component<NotificationProps> = (props) => {
    return (
        <>
            <For each={props.items}>{(item) =>
                <div class="item-row">
                    <div class="image">
                        <Image targetUrl={item.URL} imageUrl={item.ImageURL} />
                    </div>
                    <div class="text" innerHTML={item.Text}></div>
                </div>
            }</For>
        </>
    )
};

type Additions = {
    Artworks: Notification[],
    Portraits: Notification[],
    Signatures: Notification[],
    ArtworkImages: Notification[],
    Artists: Notification[],
    Articles: Notification[],
    BlogPosts: Notification[],
    CalendarEvents: Notification[],
    Letters: Notification[]
};

type State = {
    isContentReady: boolean;
}

export const RecentAdditions : Component = () => {
    const [dates, setDates] = createSignal<string[]>([]);
    const [state, setState] = createStore<State>(
        {
            isContentReady: false
        }
    );
    const [notifications, setNotifications] = createStore<Additions>({
        Artworks: [],
        Portraits: [],
        Signatures: [],
        ArtworkImages: [],
        Artists: [],
        Articles: [],
        BlogPosts: [],
        CalendarEvents: [],
        Letters: []
    });
    const load = async () => {
        const res = await fetch("/Home/GetRecentAdditionsJson");
        const json = await res.json();
        if (!json.Success) {
            return;
        }
        const data = json.Data as { Dates: string[] } & Additions;
        setDates(getDistinctDatesDescending(data.Dates));
        setNotifications("Articles", data.Articles);
        setNotifications("Artists", data.Artists);
        setNotifications("ArtworkImages", data.ArtworkImages);
        setNotifications("Artworks", data.Artworks);
        setNotifications("BlogPosts", data.BlogPosts);
        setNotifications("CalendarEvents", data.CalendarEvents);
        setNotifications("Letters", data.Letters);
        setNotifications("Portraits", data.Portraits);
        setNotifications("Signatures", data.Signatures);
    };
    const getDistinctDatesDescending = (dates: string[]): string[] =>
        Array.from(new Set(dates))
            .sort((a, b) => new Date(b).getTime() - new Date(a).getTime())
    ;
    onMount(async () => {
        await load();
        setState("isContentReady", true);
    });
    return (
        <Show when={state.isContentReady}>
            <section class="recent-additions">
                <h2 style="font-size: 1.5em; font-family: 'Oswald'; padding: 0; margin: 0;">
                    <CMS id="home/recent-additions::heading">Recent additions to the website</CMS>
                </h2>
                <p style="margin-top: 20px;">
                    <span class="fa fa-clock-o" style="margin-right: 10px;"></span> 
                    <CMS id="home/recent-additions::view-all-recent-additions">
                        View all <a class="tape" href="/News/RecentAdditions">recent additions</a>.
                    </CMS>
                </p>
                <p style="font-size: 1em;">
                    <span style="margin-right: 10px;">
                        <span style="color: #f26522;" class="fa fa-rss"></span>
                        <a class="tape" href="/Feed/RecentAdditions?format=rss">RSS</a>
                    </span>
                    <span>
                        <span style="color: #f26522;" class="fa fa-rss"></span>
                        <a class="tape" href="/Feed/RecentAdditions?format=atom">Atom</a>
                    </span>
                </p>
                <div style="margin-top: 20px;" data-role="align-height" data-offset-height="180" data-target-id="landing-page-circles">
                    <For each={dates()}>{(date) => {
                        const day = moment(date).format("YYYY-MM-DD");
                        const toDateString = (value: string) => moment(value).format("YYYY-MM-DD");
                        const byMatchingDay = (x: Notification) => toDateString(x.DateAddedUTC) == day;
                        return (
                            <div class="panel">
                                <p class="header">
                                    <b>{moment(date).format("MMMM DD, YYYY")}</b>
                                </p>
                                <Notifications items={notifications.Artworks.filter(byMatchingDay)} />
                                <Notifications items={notifications.Portraits.filter(byMatchingDay)} />
                                <Notifications items={notifications.Signatures.filter(byMatchingDay)} />
                                <Notifications items={notifications.ArtworkImages.filter(byMatchingDay)} />
                                <Notifications items={notifications.Artists.filter(byMatchingDay)} />
                                <Notifications items={notifications.Articles.filter(byMatchingDay)} />
                                <Notifications items={notifications.BlogPosts.filter(byMatchingDay)} />
                                <Notifications items={notifications.CalendarEvents.filter(byMatchingDay)} />
                                <Notifications items={notifications.Letters.filter(byMatchingDay)} />
                            </div>
                        );
                    }}</For>
                </div>
            </section>
        </Show>
    );
};